import { useCallback } from "react";
import { CommandsDirectory } from "@components/commands/lib";
import { useCommands } from "@components/commands/useCommands";
import { useTaskBulkActionsOpenOverride } from "@components/tasks/useTaskBulkActionsOpenOverride";

interface UseBillBulkCommandActionsParams {
    selectedCount: number;
    onCreateTask?: () => void;
}

/**
 * Routes the bills table's bulk-actions trigger (button and mod+k) through the
 * shared command palette (CommandsDirectory.BILL_BULK).
 */
export function useBillBulkCommandActions({
    selectedCount,
    onCreateTask,
}: UseBillBulkCommandActionsParams) {
    const { open } = useCommands();

    const handleOpenBulkActions = useCallback(() => {
        if (selectedCount === 0) {
            return;
        }
        open(CommandsDirectory.BILL_BULK, {
            selectedBillCount: selectedCount,
            onBillBulkCreateTask: onCreateTask,
        });
    }, [open, selectedCount, onCreateTask]);

    useTaskBulkActionsOpenOverride({
        selectedCount,
        openBulkActions: handleOpenBulkActions,
    });

    return { handleOpenBulkActions };
}
